/**
 * Stable per-case key shared between the UI and the claim endpoint.
 * Must match the same helper in src/app/api/advocate-search/claim/route.ts.
 */

import type { AdvocateSearchCase } from '../types';

export function caseKey(c: AdvocateSearchCase): string {
  if (c.cnr_number) return `cnr:${c.cnr_number}`;
  return `legacy:${c.court_type ?? ''}/${c.case_type ?? ''}/${c.case_number ?? ''}/${c.case_year ?? ''}`;
}
